/**
 * An animation with a read-only float output.
 *
 * Subclasses override update() to compute and set the animated value based on the current fraction.
 *
 * TypeScript port of C++ ScalarAnimation from tabanim/public/animation/ScalarAnimation.h
 */

import { Animation } from './BaseAnimation';

export abstract class ScalarAnimation extends Animation {
  private value = 0;

  constructor() {
    super();
    this.value = 0;
  }

  public getValue(): number {
    return this.value;
  }

  /**
   * Protected so only subclasses can modify the value.
   */
  protected setValue(value: number): void {
    this.value = value;
  }
}
